(function () {

  function getSwiperInstance() {
    return document.querySelector('.swiper[data-main-media]')?.swiper
      || document.querySelector('[data-main-media]')?.swiper;
  }

  function cleanFilename(src) {
    if (!src) return '';
    return src.split('?')[0].split('/').pop().toLowerCase();
  }

  function buildVariantMap(variants) {
    const map = {};
    variants.forEach(function (v) {
      if (v.featured_image && v.featured_image.src) {
        map[v.id] = cleanFilename(v.featured_image.src);
      }
    });
    return map;
  }

  // Find the script tag that contains the variants JSON array
  function getProductVariants() {
    const all = [...document.querySelectorAll('script:not([src])')];
    const tag = all.find(function (s) {
      const t = s.textContent.trim();
      return t.startsWith('[') && t.includes('featured_image') && t.includes('variants') === false && t.includes('"id"');
    }) || all.find(function (s) {
      const t = s.textContent.trim();
      return t.startsWith('[') && t.includes('featured_image') && t.includes('"id"');
    });
    if (!tag) return null;
    try {
      const parsed = JSON.parse(tag.textContent.trim());
      // It's an array of variants directly
      if (Array.isArray(parsed)) return { variants: parsed };
      // It's a product object with variants key
      if (parsed.variants) return parsed;
      return null;
    } catch (e) {
      return null;
    }
  }

  function findSlideIndex(swiper, targetFilename) {
    let matchIndex = -1;
    swiper.slides.forEach(function (slide, i) {
      if (slide.classList.contains('swiper-slide-duplicate')) return;
      const img = slide.querySelector('img');
      if (!img) return;
      const src = img.src || img.dataset.src || img.dataset.lazySrc || '';
      if (cleanFilename(src) === targetFilename) {
        matchIndex = i;
      }
    });
    return matchIndex;
  }

  function goToVariantSlide(variantId, variantMap) {
    const swiper = getSwiperInstance();
    if (!swiper) return;
    const targetFilename = variantMap[variantId];
    if (!targetFilename) return;
    const index = findSlideIndex(swiper, targetFilename);
    if (index !== -1) {
      swiper.slideTo(index, 300);
    }
  }

  function init() {
    const productData = getProductVariants();
    if (!productData || !productData.variants) {
      console.warn('[variant-filter] Could not find product variant data');
      return;
    }

    const variantMap = buildVariantMap(productData.variants);
    console.log('[variant-filter] Loaded variant map:', variantMap);

    const initialInput = document.querySelector('[name="id"]');
    if (initialInput) {
      setTimeout(function () {
        goToVariantSlide(initialInput.value, variantMap);
      }, 300);
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event.data && event.data.variant;
        if (variant) goToVariantSlide(variant.id, variantMap);
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target.matches('[name="id"]')) {
        goToVariantSlide(e.target.value, variantMap);
      }
    });

    document.addEventListener('variant:changed', function (e) {
      const variant = e.detail && e.detail.variant;
      if (variant) goToVariantSlide(variant.id, variantMap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();